import type { VoidFunctionComponent } from 'react';

import { ignoreOrResolveWord } from '../../../../utils';
import Button from '../../../generic/Button/Button';
import { UnignoreIssuesModalDetailsContainer } from '../../modals';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';

import { SELECTED_ISSUE_COUNT } from './shared';
import type { ActionButtonAndModalProps } from './shared';

type Props = ActionButtonAndModalProps & {
  areAnyIgnoredByRule: boolean;
};

/**
 * IssueDetailsActionButtonUnignore includes the button and the modal
 * for the unignore action on the issue details page and drawer. The modal state is managed
 * by useIssueDetailsModals, which passes the modal state down as context. Go see the
 * IssueDetailsModalsContext for more info.
 */
const IssueDetailsActionButtonUnignore: VoidFunctionComponent<Props> = ({
  id,
  areAnyIgnoredByRule,
}) => {
  const { unignoreModal, isAnyModalOpen } = useIssueDetailsModals();
  return (
    <>
      <Button
        type="secondary"
        size="medium"
        onClick={unignoreModal.onOpen}
        isDisabled={isAnyModalOpen}
      >
        Un{ignoreOrResolveWord().toLowerCase()}
      </Button>
      <UnignoreIssuesModalDetailsContainer
        id={id}
        show={unignoreModal.isOpen}
        onHide={unignoreModal.onClose}
        selectedIssuesCount={SELECTED_ISSUE_COUNT}
        areAnyIgnoredByRule={areAnyIgnoredByRule}
      />
    </>
  );
};

export default IssueDetailsActionButtonUnignore;
